import SiafLiteApiRepository from "../../external/siafLiteApi";

class EmailPersonalizadoService {
  constructor() {
    this.urlBase = "/integracao/email-personalizado";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  getAllFiltroAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }

  getInformacoesEmail(body) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/mensagem`).patch(body);
  }
}

export default EmailPersonalizadoService;
